export default class ChangePasswordModel {
  public password: string = '';
  public passwordConfirm: string = '';
}
